var _rect, _path, _path2, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgLogo2 = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 86,
    height: 86,
    viewBox: "0 0 86 86",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 1.5,
    width: 83,
    height: 83,
    rx: 41.5,
    fill: "#3B82F6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M63.2092 36.6769C63.0931 36.6264 60.265 35.3959 43.5206 28.1088C43.1875 27.9637 42.8101 27.9637 42.4771 28.1088L22.7885 36.6769C21.7321 37.1358 21.7422 38.6418 22.7885 39.0958C26.6134 40.7601 32.8662 43.4816 42.4771 47.664C42.8081 47.8082 43.1855 47.8099 43.5206 47.664C44.4332 47.2668 56.8687 41.855 57.4372 41.6078V55.6449C57.4372 56.3548 57.9805 56.9656 58.687 56.9985C59.4406 57.0339 60.0622 56.4312 60.0622 55.6819V41.1297C60.0622 40.9226 59.9095 40.7477 59.7049 40.7212C57.2413 40.4024 45.6226 38.8963 42.8306 38.5347C42.0231 38.4334 41.5199 37.6122 41.7322 36.8813C41.8987 36.264 42.4823 35.8707 43.0735 35.9116C43.1324 35.915 61.8376 38.3392 61.8241 38.3375C62.1736 38.3826 62.4607 38.6073 62.5987 38.9121C62.6953 39.1251 62.941 39.2228 63.1519 39.1234C63.505 38.9571 63.8113 38.7383 63.9508 38.2431C64.1299 37.6014 63.8059 36.9361 63.2092 36.6769Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M41.4489 49.7967L30.5678 45.0343C30.2995 44.9169 30 45.1155 30 45.4108V50.1217C30 54.5393 35.7103 58 43 58C50.2898 58 56 54.5393 56 50.1217V45.4108C56 45.1155 55.7004 44.9169 55.4322 45.0343L44.5503 49.7967C43.5623 50.2305 42.4379 50.2302 41.4489 49.7967Z",
    fill: "#EBF2FE"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 1.5,
    width: 83,
    height: 83,
    rx: 41.5,
    stroke: "white",
    strokeWidth: 3
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgLogo2);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Logo (2).6690753b43fb00ed3aa38ac48c74c9aa.svg";